import React, { Component } from 'react';
import '../styles/Thread.css';
import { getRedirects, createRedirect } from '../services/redirectionService';
import {
  Box,
  Paper,
  Stack,
  Typography,
  TextField,
  Button,
  Select,
  MenuItem,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Pagination,
  Tooltip
} from '@mui/material';

class Redirection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hits: [],
      page: 1,
      total_elem: 0,
      isLoading: false,
      q: '',
      form: {
        website: '',
        path: '',
        type: 'url',
        response_code: '301',
        object: 'page',
        destination: ''
      }
    };
    this.fetchPage = this.fetchPage.bind(this);
    this.onSearchSubmit = this.onSearchSubmit.bind(this);
    this.onPageChange = this.onPageChange.bind(this);
    this.onFormSubmit = this.onFormSubmit.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    this.fetchPage(1, '');
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  fetchPage(page, q) {
    this.setState({ isLoading: true });
    getRedirects(q || '', page)
      .then((result) => {
        if (!this._isMounted) return;
        this.setState({
          hits: result.redirects || [],
          page: parseFloat(result.page_nbr) || page,
          total_elem: parseFloat(result.total_elem) || 0,
          isLoading: false
        });
      })
      .catch(() => this.setState({ isLoading: false }));
  }

  onSearchSubmit(e) {
    e.preventDefault();
    this.fetchPage(1, this.state.q);
  }

  onPageChange(e, value) {
    this.fetchPage(value, this.state.q);
  }

  onFormSubmit(e) {
    e.preventDefault();
    createRedirect(this.state.form)
      .then(() => {
        this.fetchPage(1, this.state.q);
      })
      .catch(() => {});
  }

  render() {
    const { hits, page, total_elem, q, form } = this.state;
    const pageCount = Math.max(1, Math.ceil((total_elem || 0) / 10));

    return (
      <Box sx={{ p: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center" justifyContent="space-between" sx={{ mb: 2 }}>
          <Typography variant="h6">Redirections</Typography>
          <Box component="form" onSubmit={this.onSearchSubmit} sx={{ display: 'flex', gap: 1 }}>
            <TextField
              size="small"
              placeholder="Recherche"
              value={q}
              onChange={(e) => this.setState({ q: e.target.value })}
            />
            <Button type="submit" variant="contained">Search</Button>
          </Box>
        </Stack>

        <Paper variant="outlined" sx={{ mb: 2 }}>
          <Box component="form" onSubmit={this.onFormSubmit} sx={{ p: 2, display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(6, 1fr)' }, gap: 1 }}>
            <TextField size="small" label="Website" value={form.website} onChange={(e) => this.setState({ form: { ...form, website: e.target.value } })} />
            <TextField size="small" label="Path" value={form.path} onChange={(e) => this.setState({ form: { ...form, path: e.target.value } })} />
            <Select size="small" value={form.type} onChange={(e) => this.setState({ form: { ...form, type: e.target.value } })}>
              <MenuItem value="url">URL</MenuItem>
              <MenuItem value="regex">Regex</MenuItem>
            </Select>
            <Select size="small" value={form.response_code} onChange={(e) => this.setState({ form: { ...form, response_code: e.target.value } })}>
              <MenuItem value="301">301</MenuItem>
              <MenuItem value="302">302</MenuItem>
            </Select>
            <Select size="small" value={form.object} onChange={(e) => this.setState({ form: { ...form, object: e.target.value } })}>
              <MenuItem value="page">Page</MenuItem>
              <MenuItem value="tag">Tag</MenuItem>
            </Select>
            <TextField size="small" label="Destination" value={form.destination} onChange={(e) => this.setState({ form: { ...form, destination: e.target.value } })} />
            <Box sx={{ gridColumn: { sm: 'span 6' }, textAlign: 'right' }}>
              <Button type="submit" variant="outlined">Ajouter</Button>
            </Box>
          </Box>
        </Paper>

        <Paper variant="outlined">
          <TableContainer sx={{ maxHeight: '70vh' }}>
            <Table
              size="medium"
              stickyHeader
              sx={{
                tableLayout: 'fixed',
                '& tbody tr:nth-of-type(odd)': { bgcolor: 'action.hover' }
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Website</TableCell>
                  <TableCell>Path</TableCell>
                  <TableCell>Response code</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Destination</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {hits.map((item) => (
                  <TableRow key={item._id} hover>
                    <TableCell>{item._id}</TableCell>
                    <TableCell>{item.website}</TableCell>
                    <TableCell sx={{ maxWidth: 320 }}>
                      <Tooltip title={item.path || ''}>
                        <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {item.path}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                    <TableCell>{item.response_code}</TableCell>
                    <TableCell>{item.type}</TableCell>
                    <TableCell sx={{ maxWidth: 320 }}>
                      <Tooltip title={(item.destination_page || item.destination_tag || '')}>
                        <Typography variant="body2" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                          {item.destination_page || item.destination_tag}
                        </Typography>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
                {hits.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">
                      <Typography variant="body2" color="text.secondary">Aucune donnée</Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>

          <Box sx={{ px: 2, py: 1, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="caption" color="text.secondary">Page {page} / {pageCount}</Typography>
            <Pagination
              page={page}
              count={pageCount}
              onChange={this.onPageChange}
              size="small"
              color="primary"
              showFirstButton
              showLastButton
            />
          </Box>
        </Paper>
      </Box>
    );
  }
}

export default Redirection;